import React from "react";

import isEmpty from "lodash.isempty";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { useStores } from "../../contexts/StoreContext";
import Markdown from "../../shared/styles/Markdown";
import JobAlertForm from "../JobAlertForm/JobAlertForm";

const StyledFooter = styled.div`
  background-color: ${({ theme, $backgroundColour }) =>
    $backgroundColour || theme.footerBackgroundColor};
`;

function CustomFooter(props) {
  const { footerStore, modalStore } = useStores();
  const { openModal } = modalStore;

  if (isEmpty(footerStore.customDesktopFooter)) return null;
  const handleRegisterInterestClick = () => {
    openModal({
      content: (
        <JobAlertForm
          // TO DO: Add agreement content
          agreementContent=""
          privacyPolicyLink=""
          formHeaderBackgroundColour=""
        />
      ),
      size: "md",
    });
  };

  return (
    <StyledFooter $backgroundColour={props?.backgroundColour}>
      <div
        onClick={(e) => {
          if (e.target.getAttribute("data-register-interest") === "true") {
            e.preventDefault();
            handleRegisterInterestClick();
          }
        }}
      >
        <Markdown>{footerStore.customDesktopFooter}</Markdown>
      </div>
    </StyledFooter>
  );
}

CustomFooter.defaultProps = {
  backgroundColour: "",
};

CustomFooter.propTypes = {
  backgroundColour: PropTypes.string,
};

export default observer(CustomFooter);
